<script setup>
import { ref, inject } from 'vue'
import { useStore } from '@/store/bucket'
import { removeEmptyFromArray, filterArrayBySlugs, getGoogleMapURL } from '@/Shared/helper.js'
import ButtonSetInBrand from '@/Shared/ButtonSet/ButtonSetInBrand'
import ButtonClose from '@/Shared/Buttons/ButtonClose'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import ModalList from './Modal3List'

const props = defineProps({
  active: Boolean,
})
const emit = defineEmits(['toggle'])
const store = useStore()
const data = inject('data')
const category = inject('category')

const brandsInShop = (() => {
  const slugList = removeEmptyFromArray(String(ref(data.shopBrand).value).split(','))
  return filterArrayBySlugs(store.getBrandList, slugList, 'brandSlug')
})()

const brandsInNews = (() => {
  const slugList = removeEmptyFromArray(String(ref(data.newsRelBrand).value).split(','))
  return filterArrayBySlugs(store.getBrandList, slugList, 'brandSlug')
})()

const shopsInNews = (() => {
  const slugList = removeEmptyFromArray(String(ref(data.newsRelShop).value).split(','))
  return filterArrayBySlugs(store.getShopList, slugList, 'shopSlug')
})()
</script>

<template>
  <div :class="[{ active: props.active }, 'modal-accordion']">
    <ButtonClose class="right-0" @click="emit('toggle')" />

    <template v-if="category === 'brand'">
      <div class="links-in-brand">
        <ButtonSetInBrand :no-favorite="true" color="white" />
      </div>
    </template>

    <template v-if="category === 'shop'">
      <div class="links-in-shop">
        <ModalList :list="brandsInShop" category="brand" title="取り扱いブランド" />
        <ul class="btn-list mt-[40px] grid gap-[15px]">
          <!-- <li><ButtonRounded text="関連ニュース" icon="arrow" :url="`/news/all?shops=${data.shopSlug}`" /></li> -->
          <li><ButtonRounded text="Googleマップ" :url="getGoogleMapURL(data.shopNameJ, data.shopLongtitude, data.shopLangtitude)" icon="external" /></li>
        </ul>
      </div>
    </template>

    <template v-if="category === 'news'">
      <div class="links-in-news">
        <ModalList category="brand" title="関連ブランド" :list="brandsInNews" />
        <hr v-if="brandsInNews.length && shopsInNews.length" class="border-none pb-10" />
        <ModalList category="shop" title="関連ストア" :list="shopsInNews" />
        <div v-if="!brandsInNews.length && !shopsInNews.length" class="center-container h-full">
          <p class="font-[500] py-2.5 leading-[1.8] text-center">このニュースに関連する<br />ブランドやストアはありません。</p>
        </div>
      </div>
    </template>
  </div>
</template>
